// extracted by mini-css-extract-plugin
export var Project = "style-module--Project--dXmhZ";
export var Details = "style-module--Details--zU6dO";
export var Category = "style-module--Category--159Md";
export var Title = "style-module--Title--15tX6";
export var Tags = "style-module--Tags--2AhzH";
export var Links = "style-module--Links--1065d";
export var ProjectImageWrapper = "style-module--ProjectImageWrapper--2_d-y";
export var ProjectImage = "style-module--ProjectImage--1h-io";